import {
  put,
  call,
  all,
  takeLatest,
  takeEvery,
  delay,
  select,
} from "redux-saga/effects";

import { axiosDelete, axiosGet, axiosPost, axiosPut } from "../util/axios";
import { HTTP_SUCCESS_STATUSES } from "../constants/http_constants";
import { company, company_notes } from "../util/routers";

import * as actionType from "../constants/action_types";
import * as actions from "../actions/index";
import { toast } from "react-toastify";

// GET requests start
function* getAllModules(action) {
  try {
    const url = `${company}/modules`;
    let { data, status } = yield call(axiosGet, url);
    yield put(actions.GETALLMODULES_RESPONSE({ data: [...data.data], status }));
  } catch (error) {
    yield put(actions.GETALLMODULES_RESPONSE(error));
  }
}

function* getCompanies(action) {
  try {
    yield put(actions.RESET_STATE("company.update_response"));
    const url = `${company}`;
    const params = { ...action.payload };
    let { data, status } = yield call(axiosGet, url, { params });

    yield put(
      actions.GETCOMPANIES_RESPONSE({
        data: data.data,
        totalCount: data.total_records,
        status,
        region: params['region-code'],
        isWhere: params['isWhere']
      })
    );
  } catch (error) {
    yield put(actions.GETCOMPANIES_RESPONSE(error));
  }
}

function* getCompany(action) {
  try {
    yield put(actions.RESET_STATE("company.update_response"));
    yield put(actions.RESET_STATE("company.details"));
    yield put(actions.RESET_STATE("company.users"));
    yield put(actions.RESET_STATE("company.policy"));
    yield put(actions.RESET_STATE("company.modules", []));
    yield put(actions.RESET_STATE("company.invoice"));
    yield put(actions.RESET_STATE("company.subscription"));

    const url = `${company}/${action.payload.company_uid}/details`;
    let { data, status } = yield call(axiosGet, url);
    yield put(actions.GETCOMPANY_RESPONSE({ ...data.data, status }));
  } catch (error) {
    yield put(actions.GETCOMPANY_RESPONSE(error));
  }
}

function* getCompanyUser(action) {
  try {
    const url = `${company}/${action.payload.company_uid}/users`;
    const params = { ...action.payload };
    yield delay(100);
    let { data, status } = yield call(axiosGet, url, { params });
    yield put(
      actions.GETCOMPANYUSER_RESPONSE({
        ...data,
        status,
      })
    );
  } catch (error) {
    yield put(actions.GETCOMPANYUSER_RESPONSE(error));
  }
}

function* getCompanyUserStat(action) {
  try {
    const url = `${company}/${action.payload.company_uid}/users`;
    let { data } = yield call(axiosGet, `${url}/count`);
    yield put(
      actions.GETCOMPANYUSERSTAT_RESPONSE({
        ...data.data,
      })
    );
  } catch (error) {
    yield put(actions.GETCOMPANYUSERSTAT_RESPONSE(error));
  }
}

function* getSubscription(action) {
  try {
    const url = `${company}/${action.payload.company_uid}/subscriptions`;
    let { data, status } = yield call(axiosGet, url);
    yield put(actions.GETSUBSCRIPTIONS_RESPONSE({ ...data.data.subscription }));
  } catch (error) {
    yield put(actions.GETSUBSCRIPTIONS_RESPONSE(error));
  }
}

function* getSubscriptionItems(action) {
  try {
    const url = `${company}/subscriptions/items`;
    let { data, status } = yield call(axiosGet, url, action.payload);
    yield put(actions.GETSUBSCRIPTION_ITEMS_RESPONSE([...data.data]));
  } catch (error) {
    yield put(actions.GETSUBSCRIPTION_ITEMS_RESPONSE(error));
  }
}

function* getIndustry(action) {
  try {
    const url = `/master/industry`;
    let { data, status } = yield call(axiosGet, url, action.payload);
    yield put(actions.GETINDUSTRY_RESPONSE({ data: [...data.data], status, no_loader: true }));
  } catch (error) {
    yield put(actions.GETINDUSTRY_RESPONSE({ ...error, no_loader: true }));
  }
}

function* getUsage(action) {
  try {
    const url = `/usage`;
    let { data, status } = yield call(axiosGet, url, action.payload);
    yield put(actions.GETUSAGE_RESPONSE({ ...data.data, status }));
  } catch (error) {
    yield put(actions.GETUSAGE_RESPONSE(error));
  }
}

function* getModules(action) {
  try {
    let moduleCountObject = {}, params = {};
    if (action.payload.region_code) {
     params = {
        params: {
          "region-code": action.payload.region_code
        }
      }
    }
    try {
      yield put(actions.RESET_STATE("company.update_response"));
      const region_code = action.payload.region_code;
      const url = `${company}/${action.payload.company_uid}/modules`;
      let params = {}
      if (region_code) {
       params = { "region-code": region_code };
      }
      var { data, status } = yield call(axiosGet, url, params);
    } catch (error) {
      yield put(actions.GETMODULES_RESPONSE(error));
    }
    try {
      const region_code = action.payload.region_code;
      const moduleUrl = `${company}/${action.payload.company_uid}/module_count`;
      let params = {}
      if (region_code) {
        params = { "region-code": region_code };
      }
      let { data: moduleData, status: moduleStatus } = yield call(axiosGet, moduleUrl, params);
      if (moduleData) {
        let moduleCount = moduleData.data.map(module_data => {
          moduleCountObject[module_data.module_name] = module_data.module_number
        })
      }
    } catch (error) {
      yield put(actions.GETMODULES_RESPONSE(error));
    }
    let result = {
      "data": data.data,
      "moduleCountObject": moduleCountObject
    }
    yield put(actions.GETMODULES_RESPONSE({ result, status }));
  } catch (error) {
    yield put(actions.GETMODULES_RESPONSE(error));
  }
}

function* getCompanyPolicy(action) {
  try {
    const url = `${company}/policy/${action.payload.company_uid}`;
    let { data, status } = yield call(axiosGet, url);
    yield put(actions.GETCOMPANYPOLICY_RESPONSE({ ...data, status,no_loader:action.payload.no_loader }));
  } catch (error) {
    yield put(actions.GETCOMPANYPOLICY_RESPONSE({...error,no_loader:action.payload.no_loader}));
  }
}

function* getCompanyInvoice(action) {
  try {
    const InvoiceStatusColor = {
      paid: "#0e9f6e",
      payment_due: "#f39c12",
      posted: "#3498db",
      not_paid: "#c0392b",
      pending: "#4b5563",
      voided: "#c0392b",
    };
    const url = `${company}/${action.payload.company_uid}/subscriptions/invoice`;
    let page = action.payload.page;
    let offsets = yield select((state) =>
      page === 1 ? [] : state.company?.invoice?.offsets || []
    );
    if (offsets.length > page) {
      offsets = offsets.slice(2);
    }
    let { data, status } = yield call(axiosGet, url, {
      params: {
        offset: page === 1 ? null : offsets[0],
      },
    });
    offsets.unshift(data?.data?.offset);
    data?.data?.invoices?.forEach((invoice) => {
      invoice.status_color = InvoiceStatusColor[invoice.status];
    });
    yield put(
      actions.GETCOMPANYINVOICE_RESPONSE({
        ...data,
        offsets,
        status,
      })
    );
  } catch (error) {
    yield put(actions.GETCOMPANYINVOICE_RESPONSE(error));
  }
}

function* getNotes(action) {
  try {
    if (action.payload.page === 1) {
      yield put(
        actions.RESET_STATE("company.notes", {
          data: [],
          current_page: 1,
          total_pages: null,
        })
      );
      yield put(actions.RESET_STATE("company.update_response"));
    }
    const url = `${company_notes}`;
    const params = { ...action.payload };
    let { data, status } = yield call(axiosGet, url, { params });
    yield put(
      actions.GETNOTES_RESPONSE({
        ...data,
        status,
        limit: action.payload.limit,
      })
    );
  } catch (error) {
    yield put(actions.GETNOTES_RESPONSE(error));
  }
}

function* getIntegrations(action) {
  try {
    const url = `${company}/${action.payload.company_uid}/integrations`;
    const params = {
      page: action.payload.page,
      count: action.payload.limit,
      "filter.keyword": action.payload.keyword,
      "filter.company_id": action.payload.company_id,
      "filter.is_installed": 1,
    };

    let { data, status } = yield call(axiosGet, url, { params });
    yield put(
      actions.GETINTEGRATIONS_RESPONSE({
        ...data,
        status,
      })
    );
  } catch (error) {
    yield put(actions.GETINTEGRATIONS_RESPONSE(error));
  }
}

function* getCredentials(action) {
  try {
    yield put(actions.RESET_STATE("company.update_response"));
    const url = `${company}/${action.payload.company_uid}/credentials`;
    const params = {
      page: action.payload.page,
      count: action.payload.limit,
      keyword: action.payload.keyword,
    };
    let { data, status } = yield call(axiosGet, url, { params });
    yield put(
      actions.GETCREDENTIALS_RESPONSE({
        data: data.data,
        totalCount: data.total_records,
        current_page: data.current_page,
        status,
      })
    );
  } catch (error) {
    yield put(actions.GETCREDENTIALS_RESPONSE(error));
  }
}

function* getCredential(action) {
  try {
    const url = `${company}/${action.payload.company_uid}/credentials/${action.payload.credential_uid}`;
    let { data, status } = yield call(axiosGet, url);
    yield put(
      actions.GETCREDENTIAL_RESPONSE({
        data: data.data,
        status,
      })
    );
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in displaying credential details.", {
      type: "error",
    });
    yield put(actions.GETCREDENTIAL_RESPONSE(error));
  }
}

function* getCompanyStat(action) {
  try {
    const url = `${company}/${action.payload.company_uid}/dashboards`;
    let { data, status } = yield call(axiosGet, url, {
      params: { company_login_name: action.payload.company_login_name },
    });
    yield put(
      actions.GETCOMPANYSTAT_RESPONSE({
        data: data.data,
        status,
      })
    );
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in displaying insights.", {
      type: "error",
    });
    yield put(actions.GETCOMPANYSTAT_RESPONSE(error));
  }
}

// Getting the company fields, it fields that are required to build the form
function* getCompanyPolicyFields() {
  try {
    yield put(actions.RESET_STATE("company.policyFields"));
    const url = `fields/company_policy`;
    const { data: axiosData } = yield call(axiosGet, url);
    const { data, type, title, message } = axiosData; // Getting zuper response
    if (type != 'SUCCESS') {
      throw new Error(message, {
        cause: message || title
      })
    }
    yield put(actions.GET_COMPANY_POLICY_FIELDS_RESPONSE({ data: data }));
  } catch (error) {
    console.log('Error getting policy fields')
    console.error(error)
    toast(error?.cause || "Error in getting company policy fields.", {
      type: "error",
    });
  }
}

function* getWorkFlowBuilderNodeFilters(action) {
  try {
    yield put(actions.RESET_STATE("workflow_builder.node_filters"));
    const url = `fields/wfb/node_filters?company_name=${action?.payload}`;
    const { data: axiosData } = yield call(axiosGet, url);
    const { data, type, title, message } = axiosData; // Getting zuper response
    if (type != 'SUCCESS') {
      throw new Error(message, {
        cause: message || title
      });
    }
    yield put(actions.GET_WORK_BUILDER_NODE_FILTERS_RESP({ data: data }));
  } catch (error) {
    console.error(error);
    toast(error?.cause || "Error in getting company policy fields.", {
      type: "error",
    });
  } finally {
    yield put(actions.STOP_LOADER);
  }
}

function* getZuperPayDetails(action) {
  try {
    yield put(actions.RESET_STATE("company.zuper_pay"));
    const url = `${company}/${action.payload.company_uid}/zuper_pay`;
    const { data: axiosData } = yield call(axiosGet, url);
    const { data, type, title, message } = axiosData; // Getting zuper response
    if (type != 'SUCCESS') {
      throw new Error(`${axiosData?.status} `+ message, {
        cause: message || title
      });
    }
    yield put(actions.GET_COMPANY_ZUPER_PAY_DETAILS_RESPONSE({ data: data }));
  } catch (error) {
    console.error(error)
    yield put(actions.GET_COMPANY_ZUPER_PAY_DETAILS_RESPONSE({
      data: {
        type: 'error',
        error: error
      }
    }));
    yield put(actions.STOP_LOADER);
    toast(error?.cause || "Error in getting Zuper Pay Details.", {
      type: "error",
    });
  }
}
// GET requests end

// POST and PUT requests start
function* toggleCompany(action) {
  try {
    const url = `${company}/toggle/${action.payload.company_uid}/${action.payload.status}`;
    let { data, status } = yield call(axiosPut, url, {
      reason: action.payload.reason,
    });
    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Succesfully updated company status.", {
        type: "success",
      });
      yield put(
        actions.TOGGLECOMPANY_RESPONSE({
          company_uid: action.payload.company_uid,
          ...data,
          status,
        })
      );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in updating company status.", {
      type: "error",
    });
    // yield put(actions.TOGGLECOMPANY_RESPONSE(error));
  }
}

function* toggleSubscription(action) {
  try {
    const url = `${company}/${action.payload.company_uid}/subscriptions/${action.payload.type}`;
    let { data, status } = yield call(
      axiosPut,
      url,
      action.payload.type === "cancel"
        ? {
          end_of_term: true,
        }
        : {}
    );
    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Succesfully updated subscription status.", {
        type: "success",
      });
      yield put(
        actions.TOGGLESUBSCRIPTION_RESPONSE({
          company_uid: action.payload.company_uid,
          ...data,
          status,
        })
      );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in updating company status.", {
      type: "error",
    });
    // yield put(actions.TOGGLECOMPANY_RESPONSE(error));
  }
}

function* syncSubscription(action) {
  try {
    const url = `${company}/${action.payload.company_uid}/subscriptions/sync`;
    let { data, status } = yield call(axiosPut, url);
    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Succesfully synced subscription.", {
        type: "success",
      });
      yield put(
        actions.GETSUBSCRIPTIONS_REQ({
          company_uid: action.payload.company_uid,
          ...data,
          status,
        })
      );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in updating company status.", {
      type: "error",
    });
    // yield put(actions.TOGGLECOMPANY_RESPONSE(error));
  }
}

function* createCompany(action) {
  try {
    const url = `${company}`;
    if (
      action.payload.company.company_logo &&
      typeof action.payload.company.company_logo === "object"
    ) {
      const { data: uploadData } = yield call(
        axiosPost,
        `/upload`,
        { img: action.payload.company.company_logo },
        {
          headers: {
            "Content-type": "multipart/form-data",
          },
        }
      );
      action.payload.company.company_logo = uploadData?.Location;
    }
    if (
      action.payload.user.profile_picture &&
      typeof action.payload.user.profile_picture === "object"
    ) {
      const { data: uploadData } = yield call(
        axiosPost,
        `/upload`,
        { img: action.payload.user.profile_picture },
        {
          headers: {
            "Content-type": "multipart/form-data",
          },
        }
      );
      action.payload.user.profile_picture = uploadData?.Location;
    }

    action.payload.company.account_manager =
      action.payload.company.account_manager?.coworker_uid || null;

    let { data, status } = yield call(axiosPost, url, {
      ...action.payload,
    });

    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Succesfully created company.", {
        type: "success",
      });
      yield put(actions.CREATECOMPANY_RESPONSE({ data, status }));
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in creating company.", {
      type: "error",
    });
    // yield put(
    //   actions.CREATECOMPANY_RESPONSE({ error: error.message || error })
    // );
  }
}

function* editCompany(action) {
  try {
    const url = `${company}/${action.payload.company_uid}`;
    if (
      action.payload.company_logo &&
      typeof action.payload.company_logo === "object"
    ) {
      const { data: uploadData } = yield call(
        axiosPost,
        `/upload`,
        { img: action.payload.company_logo },
        {
          headers: {
            "Content-type": "multipart/form-data",
          },
        }
      );
      action.payload.company_logo = uploadData?.Location;
    }

    if (action.payload.account_manager) {
      yield call(
        axiosPut,
        `${company}/${action.payload.company_uid}/manager/${action.payload.account_manager.coworker_uid}`
      );
    }

    let { data, status } = yield call(axiosPut, url, {
      company: { ...action.payload },
    });
    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Succesfully updated company details.", {
        type: "success",
      });
      yield put(actions.EDITCOMPANY_RESPONSE({ data, status }));
      yield delay(500);
      yield put(actions.GETCOMPANY_REQ(action.payload));
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in updating company details.", {
      type: "error",
    });
    // yield put(actions.EDITCOMPANY_RESPONSE({ error: error.message || error }));
  }
}

function* updateModules(action) {
  try {
    const activationURL = `${company}/${action.payload.company_uid}/modules/all?type=ACTIVATE`;
    const deActivationURL = `${company}/${action.payload.company_uid}/modules/all?type=DEACTIVATE`;

    const activated = yield action.payload.activated.length &&
      call(axiosPut, activationURL, action.payload.activated);
    const deactivated = yield action.payload.deactivated.length &&
      call(axiosPut, deActivationURL, action.payload.deactivated);
    if (
      (action.payload.activated.length
        ? HTTP_SUCCESS_STATUSES.includes(activated?.status) &&
        activated?.data?.type === "success"
        : true) &&
      (action.payload.deactivated.length
        ? HTTP_SUCCESS_STATUSES.includes(deactivated.status) &&
        deactivated?.data?.type === "success"
        : true)
    ) {
      toast("Successfully updated the modules.", { type: "success" });
      yield put(
        actions.UPDATEMODULES_RESPONSE({
          data: {
            message: "Successfully updated the modules.",
          },
        })
      );
      yield delay(500);
      yield put(
        actions.GETMODULES_REQ({ company_uid: action.payload.company_uid })
      );
    } else {
      throw new Error(
        activated.data?.error?.message ||
        deactivated.data?.error?.message ||
        activated.data?.message ||
        deactivated.data?.message
      );
    }
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in updating company modules.", {
      type: "error",
    });
    // );
    // yield put(
    //   actions.UPDATEMODULES_RESPONSE({ error: error.message || error })
    // );
  }
}

function* toggleUser(action) {
  try {
    const params = {
      type: action.payload.type,
      fullName: action.payload.fullName,
      user_uid: action.payload.user_uid,
      company_uid: action.payload.company_uid,
    };
    const url = `${company}/${action.payload.company_uid}/users/${action.payload.user_uid}/`;
    let { data, status } = yield call(
      axiosPut,
      url,
      {},
      {
        params,
      }
    );
    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Succesfully updated user status.", {
        type: "success",
      });
      yield put(
        actions.TOGGLEUSER_RESPONSE({
          company_uid: action.payload.company_uid,
          user_uid: action.payload.user_uid,
          ...data,
          status,
        })
      );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in updating user status.", {
      type: "error",
    });
    // yield put(actions.TOGGLECOMPANY_RESPONSE(error));
  }
}

function* loginASUser(action) {
  try {
    const params = {};
    const url = `${company}/${action.payload.company_uid}/users/${action.payload.user_uid}/login`;
    const payload = {
      ...action.payload.formData,
      name: action.payload.user_name,
      remarks:
        action.payload.formData.remarks || action.payload.formData.reason,
    };
    let { data, status } = yield call(axiosPost, url, payload, {
      params,
    });
    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      yield put(
        actions.LOGINASUSER_RESPONSE({
          ...data,
          ...action.payload.formData,
          status,
        })
      );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in updating user status.", {
      type: "error",
    });
    // yield put(actions.TOGGLECOMPANY_RESPONSE(error));
  }
}

function* editCompanyPolicy(action) {
  try {
    const url = `${company}/policy/${action.payload.company_uid}`;
    let { data, status } = yield call(axiosPut, url, {
      company_policy: action.payload.formData,
    });
    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Succesfully updated company policy.", {
        type: "success",
      });
      yield put(
        actions.EDITCOMPANYPOLICY_RESPONSE({
          ...data,
          ...action.payload.formData,
          status,
        })
      );
      yield delay(500);
      yield put(actions.GETCOMPANYPOLICY_REQ(action.payload));
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in updating company policy.", {
      type: "error",
    });
    // yield put(actions.TOGGLECOMPANY_RESPONSE(error));
  }
}

function* editSubscription(action) {
  try {
    const url = `${company}/${action.payload.company_uid}/subscriptions`;
    let { data, status } = yield call(axiosPut, url, {
      subscription: action.payload.formData,
    });
    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Succesfully updated company subscription.", {
        type: "success",
      });
      yield put(
        actions.EDITSUBSCRIPTION_RESPONSE({
          ...data,
          ...action.payload.formData,
          status,
        })
      );
      yield delay(500);
      yield put(actions.SYNCSUBSCRIPTION_REQ(action.payload));
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in updating company subscription.", {
      type: "error",
    });
    // yield put(actions.TOGGLECOMPANY_RESPONSE(error));
  }
}

function* createSubscription(action) {
  try {
    const url = `${company}/${action.payload.company_uid}/subscriptions`;
    let { data, status } = yield call(axiosPost, url, {
      subscription: action.payload.formData,
    });
    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Succesfully created suscrption for company.", {
        type: "success",
      });
      yield put(
        actions.CREATESUBSCRIPTION_RESPONSE({
          ...data,
          ...action.payload.formData,
          status,
        })
      );
      yield delay(500);
      yield put(actions.GETSUBSCRIPTIONS_REQ(action.payload));
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in creating company subscription.", {
      type: "error",
    });
    // yield put(actions.TOGGLECOMPANY_RESPONSE(error));
  }
}

function* uploadNoteAttachment(company_uid, attachment, index) {
  if (!attachment.blobInfo) {
    return;
  }
  const { data: uploadData, status } = yield call(
    axiosPost,
    `/upload/attachments/${company_uid}`,
    { attachment: attachment.blobInfo },
    {
      headers: {
        "Content-type": "multipart/form-data",
      },
    }
  );
  if (HTTP_SUCCESS_STATUSES.includes(status)) {
    // attachment.attachment_url = uploadData?.Location;
    attachment.attachment_key = uploadData?.key;
    delete attachment.blobInfo;
  } else {
    throw new Error(
      `Cannot upload ${attachment.attachment_name}. Please try again.`
    );
  }
}

function* saveNote(action) {
  try {
    const url = `${company_notes}`;
    console.log(action);
    yield all(
      (action.payload.attachments || []).map((attachment, index) => {
        return call(
          uploadNoteAttachment,
          action.payload.company_uid,
          attachment,
          index
        );
      })
    );
    let { data, status } = yield call(axiosPost, url, {
      ...action.payload,
    });

    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Note created successfully.", {
        type: "success",
      });
      yield put(
        actions.SAVENOTE_RESPONSE({
          ...data,
          status,
        })
      );
      // yield delay(500);
      // yield put(
      //   actions.GETNOTES_REQ({
      //     "filter.company_id":"",
      //     limit: 10,
      //     page: 1,
      //   })
      // );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in creating note.", {
      type: "error",
    });
  }
}

function* editNote(action) {
  try {
    const url = `${company_notes}/${action.payload.note_uid}`;

    yield all(
      (action.payload.attachments || []).map((attachment) => {
        return call(
          uploadNoteAttachment,
          action.payload.company_uid,
          attachment
        );
      })
    );

    let { data, status } = yield call(axiosPut, url, {
      ...action.payload,
    });

    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Note updated successfully.", {
        type: "success",
      });
      yield put(
        actions.EDITNOTE_RESPONSE({
          ...data,
          status,
        })
      );
      // yield delay(500);
      // yield put(
      //   actions.GETNOTES_REQ({
      //     company_uid: action.payload.company_id,
      //     limit: 10,
      //     page: 1,
      //   })
      // );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in updating note.", {
      type: "error",
    });
  }
}

function* addCredential(action) {
  try {
    const url = `${company}/${action.payload.company_uid}/credential`;

    let { data, status } = yield call(axiosPost, url, {
      provider: action.payload.provider_name,
      provider_logo: action.payload.provider_logo,
      url: action.payload.url,
      username: action.payload.username,
      password: action.payload.password,
      note: action.payload.note,
    });

    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Credential created successfully.", {
        type: "success",
      });
      yield put(
        actions.ADDCREDENTIAL_RESPONSE({
          ...data,
          status,
        })
      );
      // yield delay(500);
      // yield put(
      //   actions.GETCREDENTIALS_REQ({
      //     company_uid: action.payload.company_id,
      //     limit: 10,
      //     page: 1,
      //   })
      // );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in creating credential.", {
      type: "error",
    });
  }
}

function* editCredential(action) {
  try {
    const url = `${company}/credentials/${action.payload.credential_uid}`;

    let { data, status } = yield call(axiosPut, url, {
      provider: action.payload.provider_name,
      provider_logo: action.payload.provider_logo,
      url: action.payload.url,
      username: action.payload.username,
      password: action.payload.password,
      note: action.payload.note,
    });

    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Note updated successfully.", {
        type: "success",
      });
      yield put(
        actions.EDITCREDENTIAL_RESPONSE({
          ...data,
          status,
        })
      );
      // yield delay(500);
      // yield put(
      //   actions.GETCREDENTIALS_REQ({
      //     company_uid: action.payload.company_id,
      //     limit: 10,
      //     page: 1,
      //   })
      // );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in updating credential.", {
      type: "error",
    });
  }
}

function* editZuperPayDetails(action) {
  try {
    const url = `${company}/${action.payload.company_uid}/zuper_pay`;
    const { data, status } = yield call(axiosPost, url, {
      "email": action?.payload?.email,
      "country": action?.payload?.country,
    });
    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Successfully updated company Zuper Pay Details.", {
        type: "success",
      });
      yield put(
        actions.EDIT_ZUPER_PAY_RESPONSE({
          ...data,
          status,
        })
      );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in updating Zuper Pay Details.", {
      type: "error",
    });
  } finally {
    yield delay(500);
    yield put(actions.GET_COMPANY_ZUPER_PAY_DETAILS_REQ(action.payload));
  }
}

// POST and PUT requests end

// DELETE requests start
function* deleteNote(action) {
  try {
    const url = `${company_notes}/${action.payload.note_uid}`;

    let { data, status } = yield call(axiosDelete, url);

    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Note deleted successfully.", {
        type: "success",
      });
      yield put(
        actions.DELETENOTE_RESPONSE({
          ...data,
          status,
        })
      );
      // yield delay(500);
      // yield put(
      //   actions.GETNOTES_REQ({
      //     company_uid: action.payload.company_id,
      //     limit: 10,
      //     page: 1,
      //   })
      // );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in deleting note.", {
      type: "error",
    });
  }
}
function* deleteCredential(action) {
  try {
    const url = `${company}/credentials/${action.payload.credential_uid}`;

    let { data, status } = yield call(axiosDelete, url);

    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Note deleted successfully.", {
        type: "success",
      });
      yield put(
        actions.DELETECREDENTIAL_RESPONSE({
          ...data,
          status,
        })
      );
      // yield delay(500);
      // yield put(
      //   actions.GETNOTES_REQ({
      //     company_uid: action.payload.company_id,
      //     limit: 10,
      //     page: 1,
      //   })
      // );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in deleting note.", {
      type: "error",
    });
  }
}
// DELETE requests end


function* setModuleCount(action) {
  try {
    const url = `${company}/${action.payload.company_uid}/module_count/update`;
    const body = action.payload
    let { data, status } = yield call(axiosPost, url, body);
    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Module Sequence Number Successfully Updated", {
        type: "success",
      });
      yield delay(500);
      yield put(
        actions.GETMODULES_REQ({ company_uid: action.payload.company_uid })
      );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in Updating Module Count", {
      type: "error",
    });
  }
}

function* getModuleCount(action) {
  try {
    const url = `${company}/:company_uid/module_count`;
    const params = { ...action.payload };
    let { data, status } = yield call(axiosGet, url, { params });
    yield put(
      actions.GETMODULECOUNT_RESPONSE({
        ...data,
        status,
      })
    );
  } catch (error) {
    yield put(actions.GETMODULECOUNT_RESPONSE(error));
  }
}


function* companyWatcherSaga() {
  yield all([
    takeLatest(actionType.GETMODULES_REQ, getModules),
    takeLatest(actionType.GETCOMPANIES_REQ, getCompanies),
    takeLatest(actionType.GETCOMPANY_REQ, getCompany),
    takeLatest(actionType.GETCOMPANYUSERSTAT_REQ, getCompanyUserStat),
    takeLatest(actionType.GETCOMPANYUSER_REQ, getCompanyUser),
    takeLatest(actionType.GETSUBSCRIPTIONS_REQ, getSubscription),
    takeLatest(actionType.GETSUBSCRIPTION_ITEMS_REQ, getSubscriptionItems),
    takeLatest(actionType.GETINDUSTRY_REQ, getIndustry),
    takeLatest(actionType.GETUSAGE_REQ, getUsage),
    takeEvery(actionType.TOGGLECOMPANY_REQ, toggleCompany),
    takeLatest(actionType.GETALLMODULES_REQ, getAllModules),
    takeLatest(actionType.CREATECOMPANY_REQ, createCompany),
    takeLatest(actionType.EDITCOMPANY_REQ, editCompany),
    takeLatest(actionType.UPDATEMODULES_REQ, updateModules),
    takeEvery(actionType.TOGGLEUSER_REQ, toggleUser),
    takeEvery(actionType.TOGGLESUBSCRIPTION_REQ, toggleSubscription),
    takeEvery(actionType.LOGINASUSER_REQ, loginASUser),
    takeLatest(actionType.GETCOMPANYPOLICY_REQ, getCompanyPolicy),
    takeLatest(actionType.EDITCOMPANYPOLICY_REQ, editCompanyPolicy),
    takeLatest(actionType.GETNOTES_REQ, getNotes),
    takeLatest(actionType.SAVENOTE_REQ, saveNote),
    takeLatest(actionType.EDITNOTE_REQ, editNote),
    takeLatest(actionType.DELETENOTE_REQ, deleteNote),
    takeLatest(actionType.GETINTEGRATIONS_REQ, getIntegrations),
    takeLatest(actionType.GETCREDENTIALS_REQ, getCredentials),
    takeLatest(actionType.GETCREDENTIAL_REQ, getCredential),
    takeLatest(actionType.EDITCREDENTIAL_REQ, editCredential),
    takeLatest(actionType.ADDCREDENTIAL_REQ, addCredential),
    takeLatest(actionType.DELETECREDENTIAL_REQ, deleteCredential),
    takeLatest(actionType.GETCOMPANYSTAT_REQ, getCompanyStat),
    takeLatest(actionType.GETCOMPANYINVOICE_REQ, getCompanyInvoice),
    takeLatest(actionType.SYNCSUBSCRIPTION_REQ, syncSubscription),
    takeLatest(actionType.EDITSUBSCRIPTION_REQ, editSubscription),
    takeLatest(actionType.CREATESUBSCRIPTION_REQ, createSubscription),
    takeLatest(actionType.GETMODULECOUNT_REQ, getModuleCount),
    takeLatest(actionType.SETMODULECOUNT_REQ, setModuleCount),
    takeLatest(actionType.GET_COMPANY_POLICY_FIELDS_REQ, getCompanyPolicyFields),
    takeLatest(actionType.GET_COMPANY_ZUPER_PAY_DETAILS_REQ, getZuperPayDetails),
    takeLatest(actionType.EDIT_ZUPER_PAY_REQ, editZuperPayDetails),
    takeLatest(actionType.GET_WORK_BUILDER_NODE_FILTERS_REQ, getWorkFlowBuilderNodeFilters),
  ]);
}

export default companyWatcherSaga;
